import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=489a0211&scoped=true"
import script from "./Processing.vue?vue&type=script&lang=js"
export * from "./Processing.vue?vue&type=script&lang=js"
import style0 from "./Processing.vue?vue&type=style&index=0&id=489a0211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a0211",
  null
  
)

export default component.exports